import React from 'react';
import { EyeIcon, LinkIcon, RepeatIcon, TrendingDownIcon } from 'lucide-react';
import { PAD, Reveal, SlideFrame, SlideHeader, t } from './primitives';
const SOLVES = [{
  icon: TrendingDownIcon,
  title: 'Lower campaign cost',
  description: 'Reduced cost per campaign without sacrificing quality'
}, {
  icon: RepeatIcon,
  title: 'Repeatable deployment',
  description: 'Faster campaign rollout across markets, campaign after campaign'
}, {
  icon: EyeIcon,
  title: 'Visibility & transparency',
  description: 'Central stakeholders see what is live, where, and how it performs'
}, {
  icon: LinkIcon,
  title: 'Global-to-local alignment',
  description: 'Global brand intent carried through to local affiliate execution'
}];
export function ValueProposition() {
  return <SlideFrame data-id="element-329" data-mp="nykxaqsg1dll">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-330" data-mp="nz4icgde4i3u">
        <SlideHeader eyebrow="08 — Value proposition" title="Value proposition for" accent="LEO Pharma" kicker="Snakker for LEO Pharma" data-id="element-331" data-mp="svl7ndwbt2ii" />

        <div className="mt-[3.2vh] grid min-h-0 flex-1 grid-cols-[1.4fr_1fr] gap-[1.4vw]" data-id="element-332" data-mp="164cd79t8pi3c">
          <div className="grid min-h-0 grid-cols-2 gap-[1.4vw]" data-id="element-333" data-mp="115ixrbue7h0j">
            {SOLVES.map((item, index) => {
            const Icon = item.icon;
            return <Reveal key={item.title} delay={0.2 + index * 0.08} className="flex min-h-0" data-id="element-334" data-mp="x6jxw5niqafy" data-mpi={index}>
                  <div className="flex w-full flex-col justify-between rounded-[0.9vw] border border-white/10 bg-white/[0.035] p-[1.6vw]" data-id="element-335" data-mp="1owohw37d8vgn">
                    <div className="flex items-center justify-between" data-id="element-336" data-mp="1k2ailppl246p">
                      <Icon aria-hidden className="h-[clamp(13px,1.6vw,32px)] w-[clamp(13px,1.6vw,32px)] text-[#A26BFF]" data-id="element-337" data-mp="1g2t8uk34ikvq" />
                      <span className={`${t.label} font-semibold uppercase tracking-[0.2em] text-white/30`} data-id="element-338" data-mp="27socllrqad3x">
                        {`0${index + 1}`}
                      </span>
                    </div>
                    <div className="mt-[1.6vh]" data-id="element-339" data-mp="3scteqn4xpl72">
                      <p className={`${t.lead} font-semibold leading-[1.15] text-white`} data-id="element-340" data-mp="3sc03p9yy09j4">
                        {item.title}
                      </p>
                      <p className={`${t.body} mt-[0.9vh] leading-[1.4] text-white/60`} data-id="element-341" data-mp="3jaaco58z3clv">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </Reveal>;
          })}
          </div>

          <Reveal delay={0.5} className="flex min-h-0" data-id="element-342" data-mp="3edjxdk4zsl1i">
            <div className="flex w-full flex-col justify-between bg-[#7D38E5] p-[1.8vw]" data-id="element-343" data-mp="17m1a65ina301">
              <span className={`${t.label} font-semibold uppercase tracking-[0.2em] text-white/70`} data-id="element-344" data-mp="17k84otjrpotm">
                Strategic position
              </span>
              <div data-id="element-345" data-mp="2x13ounsca2kt">
                <p className={`${t.lead} font-medium leading-[1.25] text-white`} data-id="element-346" data-mp="2s43cxw8t65ls">
                  Snakker is a strategic choice — not another agency or software vendor.
                </p>
                <p className={`${t.label} mt-[1.8vh] leading-[1.45] text-white/80`} data-id="element-347" data-mp="3229gsje6dlta">
                  Agency-quality output, lower-cost delivery, and a more controlled
                  operating model across every market.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </SlideFrame>;
}